import styled from 'styled-components';
import omitProps from 'ggApp/utils/omitProps';

const Wrap = styled.div`
    display: flex;
    flex-direction: column;
    background: ${({theme}) => theme.colors.Background};
    border: 2px solid ${({ theme }) => theme.colors['Level 1']};
    border-radius: 8px;
    padding: 16px 16px;
    overflow: hidden;
`;

const TopContentWrap = styled.div`
    display: flex;
    align-items: center;
    > * {
        margin-right: 8px;
    }
`;

const BottomContentWrap = styled(omitProps('isActive')('div'))`
    transition-property: max-height;
    transition-duration: ${({ isActive }) => (isActive ? '1s' : '0.5s')};
    transition-timing-function: ${({ isActive }) => isActive ? 'ease-in-out' : 'cubic-bezier(0, 1, 0, 1)'};
    max-height: 0;
    overflow: hidden;
    ${({ isActive }) => isActive && `
        max-height: 400px;
        margin-top: 8px;
    `}
`

const SummaryText = styled.p`
    ${({ theme }) => theme.typography.Paragraph};
    color: ${({ theme }) => theme.colors.Foreground};
    margin-top: 8px;
`;

export { Wrap, TopContentWrap, BottomContentWrap, SummaryText };
